import { render, staticRenderFns } from "./SingleDayExpenseList.vue?vue&type=template&id=640ed989&scoped=true"
import script from "./SingleDayExpenseList.vue?vue&type=script&lang=js"
export * from "./SingleDayExpenseList.vue?vue&type=script&lang=js"
import style0 from "./SingleDayExpenseList.vue?vue&type=style&index=0&id=640ed989&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "640ed989",
  null
  
)

export default component.exports